export function setAsyncInterval(fn, initialTime) {
  let nextTime = initialTime
  const overridesTimes = []

  const setNextTime = (time) => { nextTime = time }

  const setOnceNextTime = (time) => {
    overridesTimes.push(time)
  }

  const getNextTime = () => {
    return overridesTimes.shift() ?? nextTime
  }

  const that = () => {
    Promise.resolve(fn({ setNextTime, setOnceNextTime }))
      .then(() => setTimeout(that, getNextTime()))
      .catch(() => setTimeout(that, getNextTime()))
  }
  that()
}
